export class NamedMetric {
    constructor(params) {
        this.name = params.name;
        this.value = params.value;
        this.unit = params.unit;
    }
}
